import { FC } from 'react';

import { Box } from '@mui/material';

import { ILocalVuzSpeciality, IVuzInfoWithSearchPosition } from '../../types';
import { vuzCard } from './styles';
import VuzCardHeader from './VuzCardHeader';
import VuzCardList from './VuzCardList';

export interface IVuzCardProps {
  vuzInfo: IVuzInfoWithSearchPosition;
  specialities: ILocalVuzSpeciality[];
}

const VuzCard: FC<IVuzCardProps> = ({ vuzInfo, specialities }) => {
  const isOpen = specialities.length > 0;
  return (
    <Box sx={vuzCard} className="vuz-card">
      <VuzCardHeader isOpen={isOpen} vuzInfo={vuzInfo} />
      <VuzCardList specialities={specialities} searchPosition={vuzInfo.searchPosition} vuzName={vuzInfo.name} />
    </Box>
  );
};

export default VuzCard;
